import { FormSection, FormSectionBody, FormSectionHeader, FormSectionTitle } from '@/components/FormSection'
import { Loading } from '@/components/Loading'
import { useSelections } from '@/hooks'
import { useInsuranceParamsContext } from '@/layouts/Wizard'
import { Table, Tbody } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { RecapTableRow } from './Recap'

export const ParamsRecap = () => {
  const { insuranceParams: ip, isLoading: isLoadingParams } = useInsuranceParamsContext()
  const insuranceParams = ip as InsuranceParamsTravelDto

  const { data: dataDestination, isLoading: isLoadingDestination } = useSelections(SelectionType.TravelDestination)
  const destination = dataDestination?.find(d => d.id === insuranceParams?.travel?.destination)

  const { data: dataReason, isLoading: isLoadingReason } = useSelections(SelectionType.TravelReason)
  const reason = dataReason?.find(d => d.id === insuranceParams?.travel?.reason)

  const { data: dataSportType, isLoading: isLoadingSportType } = useSelections(SelectionType.TravelSportType)
  const sportType = dataSportType?.find(d => d.id === insuranceParams?.travel?.sportType)

  const { data: dataTravelType, isLoading: isLoadingTravelType } = useSelections(SelectionType.TravelType)
  const travelType = dataTravelType?.find(d => d.id === insuranceParams?.travel?.travelType)

  const isLoading = isLoadingParams || isLoadingDestination || isLoadingReason || isLoadingSportType || isLoadingTravelType

    return (
    <FormSection>

      <FormSectionHeader>
        <FormSectionTitle>Rekapitulace zadání</FormSectionTitle>
      </FormSectionHeader>

      {isLoading && <Loading large={true} />}
      {
        <FormSectionBody>
          <Table variant="unstyled">
            <Tbody>
              <RecapTableRow col1="Destinace" col2={destination?.description} />
              <RecapTableRow col1="Důvod cesty" col2={reason?.description} />
              <RecapTableRow col1="Provozované sporty během cesty" col2={sportType?.description} />
              <RecapTableRow col1="Druh cesty" col2={travelType?.description} />
            </Tbody>
          </Table>
        </FormSectionBody>
      }
    </FormSection>
    )
}